import React, { FC } from 'react';
import { Button, Typography, Unstable_Grid2 as Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { useNotify } from 'hooks';
import { useGetClientDepartmentsByStatusQuery } from 'api';
import { Loaders, ValidatedSelect } from 'components';

interface Props {
  placeholder?: string;
}

const DepartmentDropdown: FC<Props> = ({ placeholder }) => {
  const { t } = useTranslation();
  const notify = useNotify();

  const { data, isLoading } = useGetClientDepartmentsByStatusQuery(
    {},
    {
      onError: notify.queryError,
    }
  );

  const options = data?.getClientDepartmentsByStatus?.client_departments ?? [];

  return (
    <Grid container alignItems="center" marginBottom={2}>
      <Grid xs={3}>
        <Typography variant="body2">{t('admin:departments')}</Typography>
      </Grid>

      <Grid xs={8}>
        <ValidatedSelect
          margin="none"
          disableLabel
          items={options}
          name="department_id"
          placeholder={placeholder}
        />
      </Grid>

      {isLoading && (
        <Grid xs={1}>
          <Button>
            <Loaders.Button size={24} />
          </Button>
        </Grid>
      )}
    </Grid>
  );
};

export default DepartmentDropdown;
